<template>
  <el-dialog :title="$t('deleteOrgRelStaff.title')" :visible.sync="dialogVisible" width="30%" @close="handleClose">
    <div class="text-center">
      <p>{{ $t('deleteOrgRelStaff.confirmDelete') }}</p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteOrgRelStaff.cancel') }}</el-button>
      <el-button type="primary" @click="deleteOrgRelStaff">{{ $t('deleteOrgRelStaff.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteOrgRelStaff } from '@/api/frame/orgApi'

export default {
  name: 'DeleteOrgRelStaff',
  data() {
    return {
      dialogVisible: false,
      deleteOrgRelStaffInfo: {}
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.deleteOrgRelStaffInfo = params || {}
    },
    deleteOrgRelStaff() {
      deleteOrgRelStaff(this.deleteOrgRelStaffInfo).then(response => {
        this.$message.success(this.$t('deleteOrgRelStaff.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('notice')
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleClose() {
      this.deleteOrgRelStaffInfo = {}
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>